import React, { useState, useCallback, useEffect } from "react";
import {
  Page,
  Card,
  Modal,
  Text,
  Spinner,
  Image,
  Loading,
  Button,
  DataTable,
  ButtonGroup,
  Toast,
  Checkbox,
  FormLayout,
  Filters,
  TextField,
  Badge,
  Frame,
  InlineError,
  ChoiceList,
  Thumbnail,
  EmptySearchResult,
} from "@shopify/polaris";
import axios from "../Assets/Lib/axios";
import { useRef } from "react";
import emptyListImage from "../Assets/Images/emptyList.svg";
import { useNavigate } from "react-router-dom";
import { MultiSelect } from "react-multi-select-component";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import Pagination from "@mui/material/Pagination";
import EllipsisText from "react-ellipsis-text";
import moment from "moment";
import { CheckIcon } from "@shopify/polaris-icons";

const ReviewsComponent = ({ api, type }) => {
  const navigate = useNavigate();
  const addEditState = useRef("");
  const perPage = 50;
  const [ts, setTs] = useState("");
  const [availability, setAvailability] = useState("");
  const [queryValue, setQueryValue] = useState("");
  const [page, setPage] = useState(1);
  const [pageObject, setPageObject] = useState({
    isLoading: true,
    isSaving: false,
    tableItems: [],
    tableTotalPages: 0,
    isListEmpty: false,
  });
  const handleAddUser = () => {
    navigate("/admin/settings/users-and-permissions/new");
  };
  function handleFiltersQueryChange(queryValue) {
    refBoolPage.current = false;
    setQueryValue(queryValue);
  }
  function handleAvailabilityChange(availability) {
    setAvailability(availability);
  }
  const handleAvailabilityRemove = useCallback(() => setAvailability(""), []);
  const handleQueryValueRemove = useCallback(() => setQueryValue(""), []);
  const handleFiltersClearAll = useCallback(() => {
    handleAvailabilityRemove();
    handleQueryValueRemove();
  }, [handleAvailabilityRemove, handleQueryValueRemove]);

  const filters = [
    {
      key: "availability",
      label: "Filter by",
      filter: (
        <ChoiceList
          title="Filter by"
          titleHidden
          choices={[{ label: "Email", value: "email" }]}
          selected={availability || []}
          onChange={handleAvailabilityChange}
        />
      ),
      shortcut: false,
    },
  ];

  const appliedFilters = [];
  if (!isEmpty(availability)) {
    const key = "availability";
    appliedFilters.push({
      key,
      label: disambiguateLabel(key, availability),
      onRemove: handleAvailabilityRemove,
    });
  }
  const loadingMarkup = pageObject.isLoading ? <Loading /> : null;
  const emtyState = pageObject.isListEmpty ? (
    <div
      style={{
        display: "flex",
        justifyContent: "middle",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <div style={{ width: "25%" }}>
        <Image src={emptyListImage}></Image>
      </div>
      <div className="mb-3">
        <Text variant="bodyLg" as="p">
          No results found
        </Text>
      </div>
      <br />
    </div>
  ) : (
    pageObject.isLoading && (
      <div className="spinnerContainer">
        <div className="vertical-center">
          <Spinner size="large" />
        </div>
      </div>
    )
  );
  const refBoolPage = useRef(true);
  const handleChangePage = (event, value) => {
    refBoolPage.current = true;
    setPage(value);
  };

  const handleClickRow = (param) => {
    //navigate(`/admin/reviews/${type}/${param}`, "_blank");
    window.open(`/admin/reviews/${type}/${param}`, "_blank");
  };
  const [isSaving, setIsSaving] = useState(false);
  useEffect(() => {
    fetchData();
  }, [ts, availability, queryValue, page]);

  async function fetchData() {
    let responseUsers = "";
    let responseFeatures = [];

    try {
      responseUsers = await axios.get(
        `/${api}?per_page=${perPage}&page=${refBoolPage.current ? page : 1}${
          queryValue
            ? `&filter[${
                availability === "" ? "email" : availability
              }]=${queryValue}`
            : ""
        }`
      );
      setPageObject({
        ...pageObject,
        tableItems: responseUsers.data.data.data.map((item, index) => [
          item.id,
          <div className="clickableDiv" onClick={() => handleClickRow(item.id)}>
            {item?.user
              ? `${item?.user?.first_name} ${item?.user?.last_name}`
              : "-"}
          </div>,
          <div className="clickableDiv" onClick={() => handleClickRow(item.id)}>
            {item?.user ? item?.user?.email : "-"}
          </div>,
          <div className="clickableDiv" onClick={() => handleClickRow(item.id)}>
            {type === "instructors"
              ? item?.instructor && item?.instructor?.name
                ? item?.instructor?.name
                : "-"
              : item?.related_class
              ? item?.related_class?.name
              : "-"}
          </div>,
          <div className="clickableDiv" onClick={() => handleClickRow(item.id)}>
            {item?.title ? item?.title : "-"}
          </div>,
          <div className="clickableDiv" onClick={() => handleClickRow(item.id)}>
            {item?.description ? (
              <EllipsisText text={item?.description} length={20} />
            ) : (
              "-"
            )}
          </div>,
          <div className="clickableDiv" onClick={() => handleClickRow(item.id)}>
            {item?.rating !== null ? item?.rating : "-"}
          </div>,
          <div className="clickableDiv" onClick={() => handleClickRow(item.id)}>
            {item?.created_at
              ? moment(item?.created_at).format("YYYY-MM-DD HH:mm:ss")
              : "-"}
          </div>,
          // <div className="clickableDiv" onClick={() => handleClickRow(item.id)}>
          //   {item?.is_active ? "Yes" : "No"}
          // </div>,
          <ButtonGroup>
            <Button
              icon={CheckIcon}
              onClick={() => {
                refIdRow.current =
                  type === "instructors" ? item.instructor_id : item.class_id;
                refId.current = item.id;
                setActiveAccept(true);
              }}
              disabled={item?.is_active}
            >
              Accept
            </Button>
          </ButtonGroup>,
        ]),
        isLoading: false,
        isListEmpty: !responseUsers.data.data.data.length ? true : false,
        tableTotalPages: responseUsers.data.data.total,
      });
    } catch (error) {
      console.log(error);
    }

    // if (!featuresList.length)
    //   try {
    //     responseFeatures = await axios.get(`features`);
    //     setFeaturesList(
    //       responseFeatures.data.data.data.map((item, index) => {
    //         return {
    //           label: item.name,
    //           value: item.id,
    //         };
    //       })
    //     );
    //   } catch (error) {
    //     console.log(error);
    //   }
  }

  const [active, setActive] = useState(false);
  const toggleActive = useCallback(() => setActive((active) => !active), []);
  const [toastContent, setToastContent] = useState(
    "This review has been successfully accepted"
  );

  const toastMarkup = active ? (
    <Toast content={toastContent} onDismiss={toggleActive} />
  ) : null;
  const refId = useRef(null);
  const refIdRow = useRef(null);
  const [activeAccept, setActiveAccept] = useState(false);
  const handleChangeModalAccept = useCallback((activeAccept) => {
    setActiveAccept(!activeAccept);
    setIsSaving(false);
  }, []);
  const handleYesAccept = () => {
    setIsSaving(true);
    axios
      .post(
        `/${type === "instructors" ? "instructors" : "classes"}/${
          refIdRow.current
        }/reviews/${refId.current}/publish`
      )
      .then((result) => {
        toggleActive();
        setIsSaving(false);
        setActiveAccept(!activeAccept);
        setTs(+new Date());
      })
      .catch((err) => console.log(err));
  };
  return (
    <Card padding="0">
      {loadingMarkup}

      <Filters
        queryValue={queryValue}
        queryPlaceholder="Search..."
        filters={filters}
        appliedFilters={appliedFilters}
        onQueryChange={handleFiltersQueryChange}
        onQueryClear={handleQueryValueRemove}
        onClearAll={handleFiltersClearAll}
      />

      <DataTable
        columnContentTypes={["text", "text", "text", "text"]}
        headings={[
          <Text variant="bodyMd" as="p" fontWeight="medium">
            ID
          </Text>,
          <Text variant="bodyMd" as="p" fontWeight="medium">
            User
          </Text>,
          <Text variant="bodyMd" as="p" fontWeight="medium">
            Email
          </Text>,
          <Text variant="bodyMd" as="p" fontWeight="medium">
            {type === "instructors" ? "Instructor" : "Class"}
          </Text>,
          <Text variant="bodyMd" as="p" fontWeight="medium">
            Title
          </Text>,
          <Text variant="bodyMd" as="p" fontWeight="medium">
            Review
          </Text>,
          <Text variant="bodyMd" as="p" fontWeight="medium">
            Rating
          </Text>,
          <Text variant="bodyMd" as="p" fontWeight="medium">
            Created at
          </Text>,
          // <Text variant="bodyMd" as="p" fontWeight="medium">
          //   Is accepted?
          // </Text>,
          <Text variant="bodyMd" as="p" fontWeight="medium"></Text>,
        ]}
        rows={pageObject.tableItems}
        verticalAlign="middle"
        increasedTableDensity
        footerContent={
          pageObject.tableItems?.length &&
          `Showing ${pageObject.tableItems.length} of ${pageObject.tableTotalPages} results`
        }
        hasZebraStripingOnData
        // truncate
      />
      {emtyState}
      {Math.ceil(pageObject.tableTotalPages / perPage) >= 2 && (
        <div
          style={{
            paddingTop: "10px",
            textAlign: "center",
            paddingBottom: "10px",
          }}
        >
          <Pagination
            variant="outlined"
            count={Math.ceil(pageObject.tableTotalPages / perPage)}
            page={page}
            onChange={handleChangePage}
          />
          {/* <Pagination
              count={Math.ceil(pageObject.tableTotalPages / perPage)}
              page={page}
              onChange={handleChangePage}
              size="large"
            /> */}
        </div>
      )}

      <Modal
        open={activeAccept}
        onClose={handleChangeModalAccept}
        title="Accept User"
        primaryAction={{
          content: "Yes",
          onAction: handleYesAccept,
          loading: isSaving,
        }}
        secondaryActions={[
          {
            content: "No",
            loading: isSaving,
            onAction: handleChangeModalAccept,
          },
        ]}
      >
        <Modal.Section>
          <Text>
            <p>Are you sure you want to accept this review?</p>
          </Text>
        </Modal.Section>
      </Modal>
      {toastMarkup}
    </Card>
  );
  function disambiguateLabel(key, value) {
    switch (key) {
      case "taggedWith":
        return `Tagged with ${value}`;
      case "availability":
        return `Filter by ${value}`;
      default:
        return value;
    }
  }
  function isEmpty(value) {
    if (Array.isArray(value)) {
      return value.length === 0;
    } else {
      return value === "" || value == null;
    }
  }
  function getFirstNonNullValue(obj) {
    for (const value of Object.values(obj)) {
      if (value !== null) {
        return value;
      }
    }
    return null;
  }
};

export default ReviewsComponent;
